export const TRAINABILITY_LEVELS = [
  "underload",
  "suboptimal",
  "optimal",
  "supraoptimal",
  "overload",
];

const levelMeta = (color, colorHex, i18nKey, textColor = color) => ({
  color,
  textColor,
  colorHex,
  i18nKey,
});

/** Original monitoring / trainer / athlete palette. */
export const LEGACY_TRAINABILITY_LEVEL_META = {
  underload: levelMeta("#3B82F6", 0x3b82f6, "trainability_levels.underload"),
  suboptimal: levelMeta("#D4E157", 0xd4e157, "trainability_levels.suboptimal"),
  optimal: levelMeta("#22C55E", 0x22c55e, "trainability_levels.optimal"),
  supraoptimal: levelMeta("#0B5D4B", 0x0b5d4b, "trainability_levels.supraoptimal"),
  overload: levelMeta("#EF4444", 0xef4444, "trainability_levels.overload"),
};

/** V2 overview palette — keep this isolated from the legacy UI. */
export const V2_TRAINABILITY_LEVEL_META = {
  underload: levelMeta("#FFFFFF", 0xffffff, "trainability_levels.underload"),
  suboptimal: levelMeta("#4D84FF", 0x4d84ff, "trainability_levels.suboptimal", "#7EA2FF"),
  optimal: levelMeta("#00FF8C", 0x00ff8c, "trainability_levels.optimal"),
  supraoptimal: levelMeta("#FFA630", 0xffa630, "trainability_levels.supraoptimal"),
  overload: levelMeta("#FF4D5E", 0xff4d5e, "trainability_levels.overload"),
};

export const TRAINABILITY_PALETTES = {
  legacy: LEGACY_TRAINABILITY_LEVEL_META,
  v2: V2_TRAINABILITY_LEVEL_META,
};

export const TRAINABILITY_LEVEL_META = LEGACY_TRAINABILITY_LEVEL_META;

export const TRAINABILITY_NEUTRAL_COLOR = "#A8B2C1";
export const TRAINABILITY_NEUTRAL_HEX = 0xa8b2c1;

export const TRAINABILITY_MODE_KEYS = ["9030", "9060", "AL30", "AL60"];

export const resolveTrainabilityPalette = (palette = "legacy") => {
  if (palette && typeof palette === "object") return palette;
  return TRAINABILITY_PALETTES[palette] || LEGACY_TRAINABILITY_LEVEL_META;
};

export const normalizeTrainabilityLevel = (raw) => {
  if (typeof raw !== "string") return null;
  const level = raw.trim().toLowerCase();
  return TRAINABILITY_LEVELS.includes(level) ? level : null;
};

export const getTrainabilityLevelColor = (level, palette = "legacy") =>
  resolveTrainabilityPalette(palette)[level]?.color ?? TRAINABILITY_NEUTRAL_COLOR;

export const getTrainabilityLevelTextColor = (level, palette = "legacy") => {
  const meta = resolveTrainabilityPalette(palette)[level];
  return meta?.textColor ?? meta?.color ?? TRAINABILITY_NEUTRAL_COLOR;
};

export const getTrainabilityLevelHex = (level, palette = "legacy") =>
  resolveTrainabilityPalette(palette)[level]?.colorHex ?? TRAINABILITY_NEUTRAL_HEX;

export const getTrainabilityLevelI18nKey = (level) =>
  LEGACY_TRAINABILITY_LEVEL_META[level]?.i18nKey ?? null;
